<template>
  <!--card-->
  <tk-flex wrap :column="isColumn"
           :between="isBetween"
           class="card full-width"
           :middle="isMiddle" :center="isCenter"
           :around="isAround"
           :style="{ minHeight: height + 'px', width: width + '%'}">
    <slot></slot>
  </tk-flex>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      default: 100
    },
    isColumn: {
      type: Boolean,
      default: false
    },
    isMiddle: {
      type: Boolean,
      default: false
    },
    isCenter: {
      type: Boolean,
      default: false
    },
    isBetween: {
      type: Boolean,
      default: false
    },
    isAround: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 5px;
    background: #fff;
    padding: 12px 12px;
    width: 100%;
  }
</style>
